import React, { useEffect, useState, useRef } from 'react'
import style from './Upload.module.css';
import axios from 'axios';
import { DISPLAY_BATCH, DISPLAY_LOADING, DISPLAY_OPTIONS, DISPLAY_SINGLE, DISPLAY_SUCCESS } from '../../constants/constants';

const SingleUpload = ({ handleFileChange, selectedFile, bookName, setBookName, author, setAuthor, language, setLanguage, category, setCategory, handleFileUpload, handleButtonClick, fileInputRef, setDisplayStatus, categories }) => {

  const [languageList, setLanguageList] = useState([])
  const [latestBooks, setlatestBooks] = useState([]);

  useEffect(() => {
    fetchLanguage()
    fetchLatestBooks()
  }, [])

  const fetchLanguage = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/language`)
      if (res) {
        setLanguageList(res.data)
      }
    } catch (error) {
      console.error(error);

    }
  }

  const fetchLatestBooks = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/latest-books`)
      if (res) {
        setlatestBooks(res.data)
      }
    } catch (error) {
      console.error(error);

    }
  }

  function formatDate(date) {
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    };
    
    return new Intl.DateTimeFormat('en-GB', options).format(new Date(date));
  }


  return (
    <div>
      <div className={style.backbtn}>
        <button role='link' onClick={() => { setDisplayStatus(DISPLAY_OPTIONS) }}>Back</button>
      </div>
      <div className="container mt-5">
        <div className="d-flex justify-content-evenly">
      <div >
        <form className={style.uploaddiv}>

          <label>
            {selectedFile ? selectedFile.name : 'Choose a file'}
          </label>


          <div className="flex">
                <button
                  className="p-6 d-flex align-items-center justify-content-center text-white dark:text-white"
                  aria-label="Attach file"
                  onClick={handleButtonClick}
                >
              <div className="d-flex flex-row border-2 border-black">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 7C9 4.23858 11.2386 2 14 2C16.7614 2 19 4.23858 19 7V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V7C17 5.34315 15.6569 4 14 4C12.3431 4 11 5.34315 11 7V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15V7Z" fill="currentColor"></path>
                </svg>
                <span className="text-white border-2 border-white">Attach File</span>
              </div>
            </button>
            <input
              ref={fileInputRef}
              type="file"
              tabIndex="-1"
              className="hidden"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </div>

              <input
                type="text"
                placeholder="Enter Book Name"
            className={style.inputdiv}
            value={bookName}
            onChange={(e) => { setBookName(e.target.value) }}
          />
              <input
                type="text"
                placeholder="Enter Author Name"
            className={style.inputdiv}
            value={author}
            onChange={(e) => { setAuthor(e.target.value) }}
          />
          <select className={style.selectdiv} onChange={(e)=>setLanguage(e.target.value)}>
            <option value="">Select Language</option>
                {languageList.map((value, index) => (
                <option value={value.language} key={index}>{value.language}</option>
                ))}
          </select>

          <select className={style.selectdiv} onChange={(e) => { setCategory(e.target.value) }}>
            <option value="">Select A Category</option>
                {categories.map((category, index) => (
                <option value={category} key={index}>{category}</option>
                ))}
          </select>

              <button onClick={handleFileUpload} className={style.uploadBtn}>Upload Book</button>
        </form>
          </div>
          <div className="">
            <div className="row">
              <div className="col-12">
                <h2 className="mb-4">Latest Books</h2>
                <ul className="list-group" style={{ height: '420px', overflowY: 'auto' }}>
                  {latestBooks.length > 0 ? (
                    latestBooks.map((book, index) => (
                      <li key={index} className="list-group-item">
                        <h5 className="fw-bold">{book.bookName}</h5>
                        <p className="mb-1">
                          <strong>Category:</strong> {book.category} | <strong>Language:</strong> {book.language}
                        </p>
                        <p className="text-muted m-0">
                          <strong>Created At:</strong> {formatDate(book.createdAt)}
                        </p>
                      </li>
                    ))
                  ) : (
                    <p>No books found.</p>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Upload = () => {


  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedCSV, setSelectedCSV] = useState(null);
  const [displayStatus, setDisplayStatus] = useState('options');
  const [bookName, setBookName] = useState('');
  const [author, setAuthor] = useState('');
  const [category, setCategory] = useState('');
  const [language, setLanguage] = useState('');
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const [msz, setMsz] = useState('');
  const fileInputRef = useRef(null);
  const csvInputRef = useRef(null);
  // const categories = [
  //   "News",
  //   "Latest arrivals",
  //   "Fiction",
  //   "Nonfiction",
  //   "Children Books",
  //   "School Textbooks",
  //   "University textbooks",
  //   "Competitive Exams preparation material",
  //   "Information related to disability",
  //   "Information & Updates from N I E P V D",
  //   "Information & Updates from Blind Peoples Association",
  //   "Information from N A B Delhi"
  // ]


  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/ivr/categories/english`)
      if (res) {
        setCategories(res.data)
      }
    } catch (error) {
      console.error(error);

    }
  }


  useEffect(() => {
    document.title = 'Upload Portal';
    fetchCategories();
  }, [])


  const handleButtonClick = (event) => {
    event.preventDefault();
    fileInputRef.current.click();
  };

  const handleCsvBtnClick = (event) => {
    event.preventDefault();
    csvInputRef.current.click();

  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  }

  const handleFileUpload = async (e) => {
    e.preventDefault();

    if (selectedFile && bookName !== '' && category !== '' && language !== '' && author !== '') {
      console.log("inside upload function")
      setError("");
      setDisplayStatus(DISPLAY_LOADING);
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('bookName', bookName);
      formData.append('author', author);
      formData.append('category', category);
      formData.append('language', language);

      try {
        console.log(formData);
        console.log("base url : ", process.env.REACT_APP_BASE_URL);
        const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}/upload/uploadBook`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          withCredentials: true,
        });
        console.log(resp.data);
        setMsz(resp.data);
        setDisplayStatus(DISPLAY_SUCCESS);
      } catch (error) {
        console.error("Error during upload : ", error);
        setError(error.message);
      }
    } else {
      setError("Please fill a required value");
    }
  }

  const handleCSVChange = async (event) => {
    setSelectedCSV(event.target.files[0]);
  }

  const handleBatchFileUpload = async () => {
    if (!selectedFile) {
      setError("Please Upload a zip file")
    } else if (!selectedCSV) {
      setError("Please Upload a csv file ")
    } else if (selectedFile && selectedCSV) {
      setError("");
      setDisplayStatus(DISPLAY_LOADING)
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('csv', selectedCSV);

      try {

        const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}/upload/uploadBatchBooks`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          withCredentials: true,
        });
        setDisplayStatus(DISPLAY_SUCCESS);
        setMsz(resp.data);
        console.log(resp.data);
      } catch (error) {
        console.log("error uploading batch file with csv : ", error);
        setError(error.message);
      }
    }
  }

  const handleDownload = async () => {
    const s3ObjectUrl = 'https://daisy-audiobook-website-v2.s3.us-west-2.amazonaws.com/sampleCsvFile+-+Sheet1.csv';

    const downloadLink = document.createElement('a');
    downloadLink.href = s3ObjectUrl;

    downloadLink.download = 'sampleCsvFile.csv';

    // Append the link to the body
    document.body.appendChild(downloadLink);

    // Trigger the click event to start the download
    downloadLink.click();

    // Remove the link from the DOM
    document.body.removeChild(downloadLink);
  }

  const handleTestBtn = async () => {
    try {
      console.log("base url:", process.env.REACT_APP_BASE_URL);
      const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}/test`, {
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true,
      })

      console.log(resp.data);
    } catch (error) {
      console.log("error:", error);
    }
  }

  const handleHomeBtn = async () => {
    setDisplayStatus(DISPLAY_OPTIONS);
    setSelectedCSV(null);
    setSelectedFile(null);
    setAuthor('');
    setBookName('');
    setLanguage('');
    setCategory('');
  }


  const UploadOptions = () => {
    return (
      <div className={style.uploadoptdiv}>
        <button className={style.uploadBtn} onClick={() => { setDisplayStatus(DISPLAY_SINGLE) }} role='link'>Single Upload</button>
        <button className={style.uploadBtn} onClick={() => { setDisplayStatus(DISPLAY_BATCH) }} role='link'>Batch Upload</button>
      </div>
    )
  }

  const BatchUpload = () => {
    return (
      <div>
        <div className={style.backbtn}>
          <button role='link' onClick={() => { setDisplayStatus(DISPLAY_OPTIONS) }}>Back</button>
        </div>
        <div className={style.batchdetails}>
          <p>Upload mutiple daisy books in one zip file and provide the books data in a csv file in proper format</p>
          <p>Downloda the sample csv file to check the format</p>
          <button onClick={handleDownload}>Download the sample csv</button>
        </div>
        <div className={style.uploaddiv}>

          <label style={{ "marginTop": "20px" }}>
            {selectedFile ? selectedFile.name : 'Choose a zip file'}
          </label>

          <div className="flex">
            <button className="p-6 d-flex align-items-center justify-content-center  text-white dark:text-white" aria-label="Attach Zip file" onClick={handleButtonClick}>
              <div className="flex flex-row border-2 border-black">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 7C9 4.23858 11.2386 2 14 2C16.7614 2 19 4.23858 19 7V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V7C17 5.34315 15.6569 4 14 4C12.3431 4 11 5.34315 11 7V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15V7Z" fill="currentColor"></path>
                </svg>
                <span className="text-white border-2 border-white">Attach Zip File</span>
              </div>
            </button>
            <input
              accept='.Zip'
              ref={fileInputRef}
              type="file"
              tabIndex="-1"
              className="hidden"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </div>


          <label style={{ "marginTop": "20px" }}>
            {selectedCSV ? selectedCSV.name : 'Choose a csv file'}
          </label>
          <div className="flex">
            <button className={style.csvbtn} aria-label="Attach Csv file" onClick={handleCsvBtnClick}>
              <div className={style.csvbtndiv}>
                <span className="text-white border-2 border-white">Attach Csv File</span>
              </div>
            </button>
            <input
              accept='.csv'
              ref={csvInputRef}
              type="file"
              tabIndex="-1"
              className="hidden"
              style={{ display: 'none' }}
              onChange={handleCSVChange}
            />
          </div>
          <button onClick={handleBatchFileUpload}
            className={style.uploadBtn}
          >Upload Batch</button>
        </div>
      </div>
    );
  };

  const UploadingStatus = () => {
    return (
      <div className={style.loading}>
        <p>Please wait , your books are being uploaded in our database...</p>
      </div>
    )
  }

  const UploadedStatus = () => {
    return (
      <div className={style.loading}>
        <div dangerouslySetInnerHTML={{ __html: msz }}></div>
        <button onClick={() => { handleHomeBtn() }}>Home</button>
      </div>
    )
  }



  return (
    <div className={style.maindiv}>
      <div className={style.headingdiv}>
        <h1>Welcome to Book Library upload Dashboard</h1>
        <p>Upload your book here</p>
        <p>Note : If you are uploading a daisy book , then upload a zip file otherwise upload the book as it is</p>
      </div>
      {
        displayStatus === DISPLAY_OPTIONS && <UploadOptions />
      }
      {
        displayStatus === DISPLAY_SINGLE &&
        <SingleUpload
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          handleFileChange={handleFileChange}
          handleFileUpload={handleFileUpload}
          bookName={bookName}
          setBookName={setBookName}
          author={author}
          setAuthor={setAuthor}
          category={category}
          setCategory={setCategory}
          language={language}
          setLanguage={setLanguage}
          handleButtonClick={handleButtonClick}
          fileInputRef={fileInputRef}
          setDisplayStatus={setDisplayStatus}
          categories={categories}
        />
      }
      {
        displayStatus === DISPLAY_BATCH &&
        <BatchUpload />
      }
      {
        displayStatus === DISPLAY_LOADING &&
        <UploadingStatus />
      }
      {
        displayStatus === DISPLAY_SUCCESS && <UploadedStatus />
      }
      <div aria-live="assertive" className={style.errordiv}>
        <p>{error}</p>
      </div>

      {/* <div className={style.errordiv}>
          <button onClick={handleTestBtn}>Test Btn</button>
       </div> */}
    </div>
  )
}

export default Upload